import React from 'react';

export const props = {
  announcements: [],
}

const Context = React.createContext(props);

export default Context;